export default [
  {
    path: "/mulakatdegerlendirme",
    name: "mulakatdegerlendirme",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "mulakatdegerlendirme.Baslik",
      yetki: { k: [2002802] },
    },
  },
  {
    path: "/mulakatdegerlendirme/:uuid",
    name: "mulakatdegerlendirme-form",
    component: () => import("./form.vue"),
    meta: {
      public: false,
      title: "mulakatdegerlendirme.Baslik",
      navActiveLink: "mulakatdegerlendirme",
      yetki: { k: [2002802] },
    },
  },
]
